import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=5cd63f78&"
import script from "./revenue.vue?vue&type=script&lang=js&"
export * from "./revenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports